// contexts/StoreContext.js
import { createContext, useState, useContext, useEffect } from "react";

const StoreContext = createContext();

export const StoreProvider = ({ children }) => {
  // const [user, setUser] = useState(() => {
  //   const saved = localStorage.getItem("user");
  //   return saved ? JSON.parse(saved) : null;
  // });

  const [selectedStore, setSelectedStore] = useState(() => {
    const saved = localStorage.getItem("selectedStore");
    return saved ? JSON.parse(saved) : null;
  });
  const [selectedDestStore, setSelectedDestStore] = useState(() => {
    const saved = localStorage.getItem("selectedDestStore");
    return saved ? JSON.parse(saved) : null;
  });
  // Optional: Sync with session storage instead if you want the store to reset when browser closes
  // useEffect(() => {

  //   if (user) {
  //     localStorage.setItem("userCon", JSON.stringify(user));
  //   } else {
  //     localStorage.removeItem("userCon");
  //   }
  // }, [user]);

  const updateSelectedStore = (store) => {
    setSelectedStore(store);
    localStorage.setItem("selectedStore", JSON.stringify(store));
  };
  const updateSelectedDestStore = (store) => {
    setSelectedDestStore(store);
    localStorage.setItem("selectedDestStore", JSON.stringify(store));
  };
  const clearSelectedStore = () => {
    setSelectedStore(null);
    localStorage.removeItem("selectedStore");
  };
  const clearSelectedDestStore = () => {
    setSelectedDestStore(null);
    localStorage.removeItem("selectedDestStore");
  };
  const contextValue = {
    // user,
    // setUser,
    selectedStore,
    selectedDestStore,
    clearSelectedStore,
    clearSelectedDestStore,
    updateSelectedStore,
    updateSelectedDestStore,
    isStoreSelected: !!selectedStore,
    isDestStoreSelected: !!selectedDestStore,
  };

  return (
    <StoreContext.Provider value={contextValue}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error("useStore must be used within a StoreProvider");
  }
  return context;
};
// Add this to your StoreContext to clear selection

// Then add to context value
